<a class="pointer back-button"
   [class.extra-letter-spacing]="translateKey === 'common.back'"
   [class.desktop-only-text]="showTextOnlyOnDesktop"
   (click)="$event.preventDefault(); onClick.emit();">
  <i class="icon-chevron-left"></i>
  <span class="font-md back-button-text" [translate]="translateKey"></span>
</a>